import { render } from "./PaginateFoods.vue?vue&type=template&id=a7a6cf42"
import script from "./PaginateFoods.vue?vue&type=script&lang=js"
export * from "./PaginateFoods.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\rizki\\OneDrive - OneDrive\\Documents\\UPI\\SEMESTER_5\\Kualitas Perangkat Lunak\\project-cephat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__